export default __webpack_public_path__ + "static/media/logo.69b69bef.svg";